// FavouritesModal.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const FavouritesModal = ({ isOpen, onClose, favourites }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  const go = (path) => { navigate(path); onClose?.(); };

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black/50 z-50" onClick={onClose}>
      <div className="bg-white p-6 rounded-lg shadow-lg w-96 relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded">Close</button>
        <h2 className="text-lg font-bold mb-4">Favourites</h2>

        {Array.isArray(favourites) && favourites.length ? (
          <ul className="space-y-2">
            {favourites.map((favPath, i) => (
              <li key={`${favPath}-${i}`}>
                <button onClick={() => go(favPath)} className="text-blue-600 hover:underline">
                  {favPath}
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-500">You have no favourites</p>
        )}
      </div>
    </div>
  );
};

export default FavouritesModal;
